import { motion } from 'framer-motion'
import heroAsset from '@/assets/decorative/coffee-coffeeback-hero-image-transparent.png'

// Premium easing curves
const EASE_OUT_EXPO = [0.16, 1, 0.3, 1];
const EASE_IN_EXPO = [0.7, 0, 0.84, 0];

export function SplashScreen() {
    return (
        <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: EASE_IN_EXPO }}
            className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden"
        >
            {/* Premium Gradient Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#F3EFEA] via-[#EAE0D5] to-[#D4C4B5]" />

            {/* Subtle animated glow accents */}
            <motion.div
                className="absolute top-[-20%] right-[-10%] w-[600px] h-[600px] bg-[#D4A574]/20 rounded-full blur-[120px]"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
            />
            <motion.div
                className="absolute bottom-[-20%] left-[-10%] w-[500px] h-[500px] bg-[#6F4E37]/15 rounded-full blur-[100px]"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.5, ease: "easeOut", delay: 0.2 }}
            />

            {/* Main Content Container */}
            <div className="relative z-10 flex flex-col items-center justify-center">

                {/* Hero Image with premium entrance animation */}
                <motion.div
                    initial={{ opacity: 0, scale: 0.7, y: 60 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.9, y: -40 }}
                    transition={{
                        duration: 1,
                        ease: EASE_OUT_EXPO,
                        delay: 0.1,
                    }}
                    className="w-64 h-64 sm:w-72 sm:h-72 md:w-80 md:h-80 relative mb-6"
                >
                    {/* Glow behind image */}
                    <motion.div
                        className="absolute inset-0 bg-gradient-radial from-[#D4A574]/30 via-[#D4A574]/10 to-transparent rounded-full blur-2xl scale-125"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.8, delay: 0.3 }}
                    />

                    {/* Image with subtle wiggle after entrance */}
                    <motion.img
                        src={heroAsset}
                        alt="Coffeeback"
                        className="w-full h-full object-contain relative z-10"
                        style={{
                            filter: "drop-shadow(0 20px 40px rgba(111, 78, 55, 0.25)) drop-shadow(0 8px 16px rgba(111, 78, 55, 0.15))"
                        }}
                        animate={{
                            rotate: [0, -2, 2, -1, 1, 0],
                            scale: [1, 1.02, 1],
                        }}
                        transition={{
                            duration: 0.6,
                            delay: 1.3,
                            ease: "easeInOut",
                        }}
                    />
                </motion.div>

                {/* Brand Name - Italic like header/footer */}
                <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{
                        duration: 0.8,
                        ease: EASE_OUT_EXPO,
                        delay: 0.4,
                    }}
                    className="font-display text-4xl sm:text-5xl font-bold text-[#2D1810] tracking-wide italic"
                >
                    Coffeeback
                </motion.h1>

                {/* Subtle loading indicator */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.8, duration: 0.5 }}
                    className="mt-8 flex gap-1.5"
                >
                    {[0, 1, 2].map((i) => (
                        <motion.div
                            key={i}
                            className="w-2 h-2 rounded-full bg-[#6F4E37]/40"
                            animate={{
                                scale: [1, 1.3, 1],
                                opacity: [0.4, 1, 0.4],
                            }}
                            transition={{
                                duration: 1,
                                repeat: Infinity,
                                delay: i * 0.15,
                                ease: "easeInOut",
                            }}
                        />
                    ))}
                </motion.div>
            </div>
        </motion.div>
    )
}
